require('./myProfileTppRemoveConsentResumeView.scss');

//@vendors
const React = require('react');
const { getPersonTypeAndCode } = require('utilities/hash');
const PropTypes = require('prop-types');

//@commons
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');

const {
    TPP_KEY_OPERATION_TYPE_READBLE_REGISTER
 } = require('constants/operationTypes');

//@helpers
const { FormattedText } = require('core/i18n').i18n;
class MyProfileTppRemoveConsentResumeView extends React.Component {

    buildOperationParams = (consentId) => {
        const userData = getPersonTypeAndCode();
        const idUser = userData.f;
        const documentTypeUser = userData.type;
        return {
            "channel": "INT",
            "clientId": idUser,
            "clientType": documentTypeUser,
            "optional1": consentId,
            "serviceCode": TPP_KEY_OPERATION_TYPE_READBLE_REGISTER
        }
    }

    buildSignatureSection = () => {
        const {consentId} = this.props;
        return (
            <div className="tpp-consent-resume__signature-pattern">
                <div className="tpp-consent-resume__divider" />
                <SignaturePattern
                    operationType={TPP_KEY_OPERATION_TYPE_READBLE_REGISTER}
                    operationParams={this.buildOperationParams(consentId)}
                />
            </div>
        )
    }

    buildAfectedProductsLabel = (productsAffected) => (
        <div>
            {productsAffected.map(
                product => <p key={product.iban} className="tpp-key-resume__content-value">{product.alias} - {product.iban}</p>
            )}
        </div>
        );

    render() {
        const {
            productsAffected
        } = this.props;
        const signaturePatternSection = this.buildSignatureSection();
        const affectProducts = this.buildAfectedProductsLabel(productsAffected);

        return (
            <div className="tpp-consent-resume__container">
                <div className="tpp-key-resume__title">
                    <FormattedText value="keysTppView-resumeTPPKeyTitle" />
                </div>
                <div className="tpp-consent-resume__sub-title">
                    <FormattedText value="keysTppView-removeTPPKeyConfirmTitle"/>
                </div>
                <div className="tpp-consent-resume__content">
                    <div className="tpp-consent-resume__content-item">
                        <div className="tpp-consent-resume__content-label">
                            <FormattedText value="keysTppView-consentProductsTitle" />
                        </div>
                        {affectProducts}
                    </div>
                </div>
                {signaturePatternSection}
            </div>
        );
    }
}

MyProfileTppRemoveConsentResumeView.propTypes = {
    consentId: PropTypes.string.isRequired,
    productsAffected: PropTypes.array
}

module.exports = MyProfileTppRemoveConsentResumeView;
